import { opacify } from 'polished';
export var shadowTokens = {
  heavy: function heavy(_ref) {
    var token = _ref.token;
    return "0 .8rem 2.4rem ".concat(opacify(-0.9, token('palette.grey.900')));
  },
  medium: function medium(_ref2) {
    var token = _ref2.token;
    return "0 .4rem 1.2rem ".concat(opacify(-0.9, token('palette.grey.900')));
  },
  light: function light(_ref3) {
    var token = _ref3.token;
    return "0 .4rem 1.2rem ".concat(opacify(-0.95, token('palette.grey.900')));
  },
  ultralight: function ultralight(_ref4) {
    var token = _ref4.token;
    return "0 .2rem 1rem ".concat(opacify(-0.95, token('palette.grey.900')));
  },
  menu: function menu(_ref5) {
    var token = _ref5.token;
    return "0 .2rem .4rem  ".concat(opacify(-0.9, token('palette.grey.900')), ", ") + "0 .4rem .8rem ".concat(opacify(-0.84, token('palette.grey.900')), ", ") + "0 .8rem 1.4rem -.1rem ".concat(opacify(-0.9, token('palette.grey.900')));
  },
  focus: function focus(_ref6) {
    var token = _ref6.token;
    return "0 0 0 0.3rem ".concat(opacify(-0.4, token('color.border.input.focus')));
  },
  menuFilter: function menuFilter(_ref7) {
    var token = _ref7.token;
    return "drop-shadow(0 .2rem .4rem  ".concat(opacify(-0.9, token('palette.grey.900')), ") ") + "drop-shadow(0 .4rem .8rem ".concat(opacify(-0.84, token('palette.grey.900')), ") ") + "drop-shadow(0 .8rem 1.4rem ".concat(opacify(-0.9, token('palette.grey.900')), ") ");
  }
};